import React, { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { courseURL } from "../../Hooks/URL";
import { userContext } from "../../Contexts/userContext";
import AddCourse from "../../Templates/Courses/AddCourse/AddCourse";
import useFetchWhen from "../../Hooks/useFetchWhen";

function AddCoursePage({ Edit = false, attributesEdit = false }) {
  const { contextData, setContextData } = useContext(userContext);
  const navigate = useNavigate();
  let { id } = useParams();
  const url = `${courseURL}/${id}`;
  const { data, loading, error } = useFetchWhen(
    url,
    Edit && contextData?.role == "admin"
  );
  const [course, setCourse] = useState("");

  useEffect(() => {
    if (!loading && !error && data) {
      setCourse(data?.data);
    }
  }, [data, loading, error]);

  useEffect(() => {
    setContextData({ ...contextData, page: "programs", data: "" });
  }, []);

  return (
    <AddCourse
      Edit={Edit}
      course={course}
      loading={loading || course == ""}
      url={url}
      attributesEdit={attributesEdit}
    />
  );
}

export default AddCoursePage;
